import React, { useEffect, useState, useContext } from "react";


export const Home = (props) => {

    return (
        <>
            <div className="vh-100">
                <div className="container-fluid">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 p-lg-5 my-3">
                                <p className="text-center h1 text-uppercase text-header">Ferretti Group <br />Animations Suite</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 p-lg-5 my-3 text-center">
                                <img src="/images/logo-fg.svg" style={{ width: '25%' }} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 p-lg-5 my-3">
                                <p className="text-center">- Release 0.24 -</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;
